import { FC } from 'react';

import { CompanyPromotionItemProps } from './CompanyPromotionGroupInterface';
import {
  PromotionLabel,
  StyledCompanyPromotionItem,
} from './PromotionGroupStyle';

const CompanyPromotionItem: FC<CompanyPromotionItemProps> = (props) => {
  const { text, logo, ...otherProps } = props;

  return (
    <StyledCompanyPromotionItem {...otherProps}>
      <img src={logo} alt='promotion item' />
      <PromotionLabel>{text}</PromotionLabel>
    </StyledCompanyPromotionItem>
  );
};

export default CompanyPromotionItem;
